import UpdateSuccessComponent from '../CommonScreenComponents/UpdateSuccessComponent'

const AddQuoteSuccess = ({ onNavigate }) => {
	return (
		<UpdateSuccessComponent ctaText="Continue to quote screen" continueButtonOnclick={onNavigate} />
	)
}

export default AddQuoteSuccess
